var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.theApp)?_c('a-layout-sider',{staticClass:"bh-menu-left",attrs:{"width":'auto'}},[_c('bar'),_c('a',{class:_vm.$style.air__menuLeft__backdrop,attrs:{"href":"javascript: void(0);"},on:{"click":_vm.toggleMobileMenu}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }